export default {
    inquiryAndAttendance: 'คำร้องขอและการเข้างาน',
    inquiry: 'คำร้องขอนอกสถานที่',
    inquiryLeave: 'คำร้องขอลา',
    searchByEmployeeName: 'ค้นหาจากชื่อ',
    search: 'ค้นหา',
    allStatus: 'ทุกสถานะ',
    pending: 'กำลังดำเนินการ',
    approve: 'อนุมัติ',
    reject: 'ไม่อนุมัติ',
    employeeName: 'ชื่อ - นามสกุล',
    group: 'กลุ่ม',
    department: 'แผนก',
    type: 'ประเภท',
    inquiryDate: 'วันส่งคำร้องขอ',
    period: 'ระยะการลา',
    fullDay: 'เต็มวัน',
    halfDay: 'ครึ่งวัน',
    status: 'สถานะ',
    cannotEditTheApproval: 'ไม่สามารถแก้ไขคำขอที่อนุมัติแล้วได้',
    cannotEditTheRejected: 'ไม่สามารถแก้ไขคำขอที่ถูกยกเลิกแล้วได้',
    statusAttendance: 'สถานะเข้างาน',
    manageAttendance: 'จัดการข้อมูลการลงเวลา',
    overtimeRequest: 'คำขอ OT',
    punchLog: 'บันทึกการเข้าออก',
    checkInLocation: 'สถานที่'
}
